import React, { useState, useEffect } from "react";
import FlipTipIcon from "../../assets/icons/flip-tip.svg";
// import FlipTipBanner from "../../assets/images/flip-tip-banner.svg";

interface FloatingTooltipProps {
  message: string;
  tip?: string;
  isVisible: boolean;
  onClose: () => void;
  duration?: number;
}

const FloatingTooltip: React.FC<FloatingTooltipProps> = ({
  message,
  tip,
  isVisible,
  onClose,
  duration = 8000,
}) => {
  const [shouldShow, setShouldShow] = useState(false);

  useEffect(() => {
    if (isVisible) {
      setShouldShow(true);
      const timer = setTimeout(() => {
        setShouldShow(false);
        setTimeout(onClose, 300);
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [isVisible, duration, onClose]);

  if (!isVisible && !shouldShow) return null;

  return (
    <div className={`floating-tooltip ${shouldShow ? "visible" : ""}`}>
      <div className="floating-tooltip__card">
        <button
          className="floating-tooltip__close"
          onClick={() => {
            setShouldShow(false);
            setTimeout(onClose, 300);
          }}
        >
          ×
        </button>
        {/* <img
          src={FlipTipBanner}
          alt="Flip Tip Banner"
          className="floating-tooltip__banner"
        /> */}
        <div className="floating-tooltip__content">
          <p className="floating-tooltip__message">{message}</p>
          {tip && <p className="floating-tooltip__tip">💡 {tip}</p>}
        </div>
      </div>
      <img
        src={FlipTipIcon}
        alt="Flip Tip"
        className="floating-tooltip__icon"
      />
    </div>
  );
};

export default FloatingTooltip;
